<template lang="pug">
div
  #preloader(v-if="loading")
    #loader
</template>
<script>
export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      loading: false
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    }
  },
  created() {
    var q = this.$route.query;
    // console.log(q.amount, q.promo)
    this.paymentGateWaySubmit(q.amount, q.promo);
  },
  methods: {
    paymentGateWaySubmit(deposit_amount, package_id) {
      // if(package_id === '0'){
      //   package_id = ""
      // }  
      if (this.accountID && this.sessionToken) {
        this.loading = true
        let account_id = this.accountID;
        let auth_token = this.sessionToken;
        this.$store
          .dispatch("user/gspayEwallet", {
            account_id,
            deposit_amount,
            package_id,
            auth_token
          })
          .then(response => {
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              this.loading = false
              window.location.href= response.data
            } else {
              this.loading = false
              var vm = this;
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false;
            this.feedback.success = false;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>
